import React from "react";

export default function Loading({ message = "SYNCING TRANSMISSIONS" }) {
  return (
    <div className="flex items-center justify-center py-20" data-testid="loading">
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-2 border-[color:var(--sat-cyan)] border-t-transparent rounded-full animate-spin mb-4" />
        <div className="sat-label text-[color:var(--sat-cyan)]">{message}</div>
      </div>
    </div>
  );
}
